import { UntypedFormControl } from '@angular/forms';

export class Package {
  packageUom: UntypedFormControl;
  partNumber: UntypedFormControl;
  title: UntypedFormControl;
  orderable: UntypedFormControl;
  quantity: UntypedFormControl;
  dimensionsUom: UntypedFormControl;
  dimensionsLength: UntypedFormControl;
  dimensionsWidth: UntypedFormControl;
  dimensionsHeight: UntypedFormControl;
  weightVariance: UntypedFormControl;
  weight: UntypedFormControl;
  weightUom: UntypedFormControl;
  dimensionalWeight: UntypedFormControl;
  packageLevelGtin: UntypedFormControl;
  stackingFactor: UntypedFormControl;
  packageBarCodeCharacters: UntypedFormControl;
  electronicProductCode: UntypedFormControl;
  innerQuantity: UntypedFormControl;
  innerQuantityUom: UntypedFormControl;
  language: UntypedFormControl;
  shippingScope: UntypedFormControl;
  bulk: UntypedFormControl;
  regulatingCountry: UntypedFormControl;
  transportMethod: UntypedFormControl;
  regulated: UntypedFormControl;
  hazardousClass: UntypedFormControl;
  outerPackageLabel: UntypedFormControl;
  unnaidCode: UntypedFormControl;
  shippingName: UntypedFormControl;
  description: UntypedFormControl;
  hazardousMaterialCodeQualifier: UntypedFormControl;
  hazardousMaterialClassCode: UntypedFormControl;
  hazardousMaterialDescription: UntypedFormControl;
  whmisCode: UntypedFormControl;
  whmisFreeText: UntypedFormControl;
  packingGroupCode: UntypedFormControl;
  regulationsExemptionCode: UntypedFormControl;
  hazardousPlacardNotation: UntypedFormControl;
  textMessage: UntypedFormControl;
}
